/* eslint-disable prettier/prettier */
import { Input, Button } from '@grupoboticario/flora-react';
import { Popover } from 'components/Popover';
import { useWindowSize } from 'hooks';
import { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { useTheme } from 'styled-components';
import { Search } from './styles';

interface SeachTermsProps {
  onChange: (...args: any[]) => void;
  value: string;
}

export function SearchTerms({ onChange, value }: Readonly<SeachTermsProps>) {
  const [inputIsOpen, setInputIsOpen] = useState(false);
  const theme = useTheme();
  const {
    breakpoints: { isSm },
  } = useWindowSize();
  return (
    <Search>
      {!isSm ? (
        <Input
          onChange={({ target }) => onChange(target.value)}
          value={value}
          placeholder=""
          color=""
          id="terms"
          label="Busca"
          rightIcon={<FiSearch size={17} color={theme.colors.main} />}
        />
      ) : (
        <Popover
          visible={inputIsOpen}
          position="left"
          content={
            <Input
              autoFocus
              onBlur={() => setInputIsOpen(false)}
              placeholder="Busca"
              onChange={({ target }) => onChange(target.value)}
              value={value}
              id="terms"
              label=""
            />
          }
        >
          <Button
            size="small"
            type="button"
            hierarchy="secondary"
            onClick={() => setInputIsOpen(true)}
          >
            <FiSearch />
          </Button>
        </Popover>
      )}
    </Search>
  );
}
